import React from "react";

import { Toolbar } from "./toolbar/toolbar";
import s from "./view.module.scss";
import { DivPx } from "@moai/core";
import { Prefs } from "prefs/prefs";
import { Tree } from "./tree/tree";
import { Border } from "@tableplus/toolkit";

interface Props {
    prefs: Prefs;
    value: string;
}

export const View: React.FC<Props> = ({ prefs, value }) => {
    return (
        <div className={s.container}>
            <div className={s.toolbar}>
                <Toolbar prefs={prefs} />
            </div>
            <div className={s.line}>
                <DivPx size={16} />
                <Border color="strong" />
                <DivPx size={16} />
            </div>
            <div className={s.tree}>
                <Tree value={value} />
            </div>
        </div>
    );
};
